import { ClusterItem } from '@common/state/modules/mediaDetails/models';

export const filterClustersWithCustomLabels = (clusterList: ClusterItem[]) => {
  // find all cluster labels that were not auto generated
  // filter out labels that match the auto generated label formats
  const overlayGroupRe = /^Overlay Group \d+$/;
  // const mergedGroupRe = /^Merged Group \d+$/; // for now treat as custom
  // const newGroupRe = /^New Group \d+$/; // for now treat as custom
  return clusterList.filter(
    (cl) => cl.userLabel && !overlayGroupRe.test(cl?.userLabel) // &&
    // !mergedGroupRe.test(cl?.userLabel) &&
    // !newGroupRe.test(cl?.userLabel)
  );
  // .map((cl) => ({
  //   id: cl.id,
  //   label: cl.userLabel!, // safe due to filter check
  // }));
};

export const nextMergedGroupLabel = (
  clusterList: readonly ClusterItem[]
): string => {
  let lastMergeGroupNum = 0;
  const re = /^Merged Group (\d+)$/;

  for (const cluster of clusterList) {
    if (cluster.userLabel) {
      const match = cluster.userLabel?.match(re);
      const matchNum = match?.[1];
      if (matchNum) {
        const groupNum = parseInt(matchNum, 10);
        lastMergeGroupNum = Math.max(lastMergeGroupNum, groupNum);
      }
    }
  }
  return `Merged Group ${lastMergeGroupNum + 1}`;
};

export const nextNewGroupLabel = (
  clusterList: readonly ClusterItem[]
): string => {
  let lastMergeGroupNum = 0;
  const re = /^New Group (\d+)$/;

  for (const cluster of clusterList) {
    if (cluster.userLabel) {
      const match = cluster.userLabel?.match(re);
      const matchNum = match?.[1];
      if (matchNum) {
        const groupNum = parseInt(matchNum, 10);
        lastMergeGroupNum = Math.max(lastMergeGroupNum, groupNum);
      }
    }
  }
  return `New Group ${lastMergeGroupNum + 1}`;
};
